import {SearchableItemService} from "../../../../services/SearchableItemService";
import {textFilterParamsValues} from "../../reactTableController";
export const reactAccountCols = function ( translate, userService) {
    return [ {
        field: "shortName",
        headerName: translate.instant('ACCOUNT_NAME'),
        sortable: true,
        filter: 'agTextColumnFilter',
        filterParams: textFilterParamsValues
    },{
        field: "accountNumber",
        headerName: translate.instant('ACCOUNT_NUMBER'),
        sortable: true,
        filter: 'agTextColumnFilter',
        filterParams: textFilterParamsValues
    },{
        field: "userDefinedAlias1",
        headerName: translate.instant('ACCOUNT_ALIAS'),
        sortable: true,
        filter: 'agTextColumnFilter',
        filterParams: textFilterParamsValues
    },{
        field: "bank",
        headerName: translate.instant('BANK'),
        sortable: true,
        filter: "agSetColumnFilter",
        filterParams: { values: params => {// fetch values from server
                new SearchableItemService(userService).readKindItems(['bank'])
                    .then(data => params.success(data.map(it => it.name)));
            }}
    }, {
        field: "bic",
        headerName: translate.instant('BIC'),
        sortable: true,
        filter: 'agSetColumnFilter',
        filterParams: { values: params => {// fetch values from server
                new SearchableItemService(userService).readKindItems(['bic'])
                    .then(data => params.success(data.map(it => it.code)));
            }}
    },{
        field: "countryName",
        headerName: translate.instant('COUNTRY'),
        sortable: true,
        filter:  "agSetColumnFilter",
        filterParams: { values: params => {// fetch values from server
                new SearchableItemService(userService).readKindItems(['country'])
                    .then(data => params.success(data.map(it => it.name)));
            }}
    },{
        field: "currencyCode",
        headerName: translate.instant('CURRENCY'),
        sortable: true,
        filter: "agSetColumnFilter",
        filterParams: { values: params => { // fetch values from server
                new SearchableItemService(userService).readKindItems(['currency'])
                    .then(data => params.success(data.map(it => it.code)));
            }}
    }];
}
